export const API_KEY = "AIzaSyChU5lNgwWKHNPHxbHEdVReWCazPhZhG8k";



export default API_KEY;
